import { Modal, Input, Tag, Space, Row, Button, Divider} from "antd";
import React, { useEffect, useState } from "react";
import { TagOutlined } from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import { stringToColor } from "../../Utils"

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [value, setValue] = useState(null)
    const [tags, setTags] = useState([])

    function handleClose(removedTag) {
        const newTags = tags.filter((tag) => tag !== removedTag)
        setTags(newTags)
    }

    function handleInputConfirm(e) {
        if (e && e.preventDefault)
            e.preventDefault()
        if (value && tags.indexOf(value) === -1) {
            setTags([...tags, value])
        }
        setValue('')
    }

    function loadTags() {
        var tagArr = []
        for (var i = 0; i < tags.length; i++) {
            const str = tags[i]
            tagArr.push(
                <Tag
                    closable
                    color={stringToColor(str)}
                    onClose={(e) => {
                        if (e && e.preventDefault) {
                            e.preventDefault()
                            handleClose(str)
                        }
                    }}
                >
                    {str}
                </Tag>
            )
        }
        return tagArr
    }

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <TagOutlined /> Tags
            </FilterButton>
            <Modal
                title='Tag Filter'
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        var tagStr = ""
                        for (var i = 0; i < tags.length; i++) {
                            if (i !== 0)
                                tagStr += "," + tags[i]
                            else {
                                tagStr += tags[i]
                            }
                        }
                        props.onChange({
                            tagsFilter: {
                                text: "Tags: ",
                                value: tagStr
                            }
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                    <Row>
                        <Space direction="vertical" size="small" style={{width: "100%"}}>
                            <Input
                                placeholder='Please input a tag and press enter'
                                allowClear
                                value={value}
                                onChange={(e) => {
                                    setValue(e.target.value)
                                }}
                                onPressEnter={handleInputConfirm}
                            />
                            <Button
                                size="small"
                                onClick={(e) => {
                                    setTags([])
                                }}
                                style={{marginBottom:"5px"}}
                            >
                                Clear Tags
                            </Button>
                        </Space>
                    </Row>
                    <Row>
                        {loadTags()}
                    </Row>
                </Space>
            </Modal>
        </>
    )
}